export const ADDMENPRODREQUST = "ADDMENPRODREQUST"
export const ADDMENPRODSUCCESS= "ADDMENPRODSUCCESS"
export const ADDMENPRODFAILURE ="ADDMENPRODFAILURE"

export const DELETEMENPRODREQUST = "DELETEMENPRODREQUST"
export const DELETEMENPRODSUCCESS= "DELETEMENPRODSUCCESS"
export const DELETEMENPRODFAILURE ="DELETEMENPRODFAILURE"

export const ADDMENAMOUNTREQUST = "ADDMENAMOUNTREQUST"
export const ADDMENAMOUNTSUCCESS= "ADDMENAMOUNTSUCCESS"
export const ADDMENAMOUNTFAILURE ="ADDMENAMOUNTFAILURE"



export const REDUCEMENAMOUNTREQUST = "REDUCEMENAMOUNTREQUST"
export const REDUCEMENAMOUNTSUCCESS= "REDUCEMENAMOUNTSUCCESS"
export const REDUCEMENAMOUNTFAILURE ="REDUCEMENAMOUNTFAILURE"